import { render } from "./PieSummary.vue?vue&type=template&id=853d43de"
import script from "./PieSummary.vue?vue&type=script&lang=js"
export * from "./PieSummary.vue?vue&type=script&lang=js"

import "./PieSummary.vue?vue&type=style&index=0&id=853d43de&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__